
import { Fraga } from "@/types/riskbedomning";

export const chemicalRiskFragor: Fraga[] = [
  {
    id: "kemiska-biologiska",
    text: "Finns det risk att hälsofarliga kemiska eller biologiska ämnen hanteras som medför särskild fara för hälsa och säkerhet, eller omfattas av krav på medicinsk kontroll?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att särskilda medicinska kontroller krävs men inte genomförs för de som utsätts för ämnena?",
      "Riskerar arbete med damm (asbest, kvarts m.fl.) att ske utan tillräckliga skyddsåtgärder?"
    ]
  }
];
